
(function(table) {
    

publishingApp.directive('table', ['$document', '$window', '$compile', function($document, $window, $compile) {
    return {
        restrict: 'A',
        scope: true,
        link: function (scope, element, attrs) {

            element.bind('click', function (event) {

                var $this = $(event.target);
                if($this.hasClass('div-table-col')){
                    if(!$this.hasClass('highlighted')){
                        // $log.log($this.parent().parent())
                        $this.parent().parent().find('.div-table-col').removeClass('highlighted');
                        $this.addClass('highlighted');
                    }
                }

            });
        }
    }
}]);
}('table'));

